<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div style="padding: 12px 48px;height: 100%;">
        <v-row>
          <v-col>
            <h2>รายงาน Friend Get Friend</h2>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="memberSearch"
              label="ค้นหา ชื่อ / เบอร์โทร"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card>
          <v-tabs v-model="tab" color="#1b437c">
            <v-tab>
              <h4>สมัครสมาชิก</h4>
            </v-tab>
            <v-tab>
              <h4>ใช้งานในระบบ</h4>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-data-table
                :headers="columns"
                :items="dataItem"
                :search="memberSearch"
                :custom-filter="memberFilter"
                :items-per-page="10"
                class="elevation-1"
                style="padding-top: 10px"
              >
                <template v-slot:[`item.LAST_DATE`]="{ item }">
                  {{ thaiFormattedDate(item.LAST_DATE) }}
                </template>
                <template v-slot:[`item.packagePrice`]="{ item }">
                  {{ formatNumber(item.packagePrice) }}
                </template>
                <template v-slot:[`item.packageExpri`]="{ item }">
                  {{ item.packageExpri }}
                </template>
                <template v-slot:[`item.packageImg`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.packageImg" alt="img"
                  /></v-avatar>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="columns1"
                :items="dataItem1"
                :search="memberSearch"
                :custom-filter="memberFilter"
                :items-per-page="10"
                class="elevation-1"
                style="padding-top: 10px"
              >
                <template v-slot:[`item.packageImg`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.packageImg" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="btn-color"
                        fab
                        dark
                        small
                        @click="
                          ;(dialogPackageMember = true),
                            getDataPackageMember(item)
                        "
                      >
                        <v-icon dark> mdi-account-multiple-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>ลูกค้าที่ใช้แพคเกจ</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card>

        <v-dialog v-model="dialogPackageMember" persistent max-width="50%" content-class="dialog-pin-top">
          <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-container>
                <v-row style="padding-top:15px;padding-bottom:15px">
                  <v-col style="padding: 15px 16px 0px">
                    <h3>ลูกค้าที่ใช้บริการ</h3>
                  </v-col>
                  <v-col cols="12" sm="6" style="padding: 10px 16px 0px">
                    <v-text-field
                      v-model="memberSearch"
                      label="ค้นหา ชื่อ / เบอร์โทร"
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      dense
                      clearable
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn
                      small
                      fab
                      color="#E0E0E0"
                      @click="dialogPackageMember = false"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
                {{ exPackage }}
                <v-row>
                  <v-col style="padding: 0px 16px">
                    <v-data-table
                      :headers="columns1"
                      :items="dataItem1"
                      :search="memberSearch"
                      :custom-filter="memberFilter"
                      :items-per-page="10"
                      class="elevation-1"
                      style="padding-top: 10px"
                    >
                      <template v-slot:[`item.picture`]="{ item }">
                        <v-avatar color="primary" size="40">
                          <img :src="item.picture" alt="img"
                        /></v-avatar>
                      </template>
                      <template v-slot:[`item.exPackage`]="{ item }">
                        {{ thaiFormattedDate(item.exPackage) }}
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import memberSearch from '@/mixins/memberSearch'

export default {
  mixins: [memberSearch],
  components: {},
  data () {
    return {
      PK: '',
      path: '/package/', // Path Model
      PATH: '/packageQRcode/',
      returnLink: '/Master/Package',
      session: this.$session.getAll(),
      tab: null,
      dialogPackageMember: false,
      valid: true,
      columns: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'ผู้เชิญ', value: 'packageName' },
        {
          text: 'จำนวนการเชิญ/คน',
          value: 'packageCount',
          align: 'center'
        },
        {
          text: 'คะแนนที่ได้รับทั้งหมด',
          value: 'packagePrice',
          align: 'center'
        }
        // { text: 'คะแนนที่ได้ต่อครั้ง', value: 'packagePoint', align: 'center' },
        // { text: 'รายละเอียด', value: 'packageDetail' },
        // { text: 'อายุการใช้งาน', value: 'packageExpridate', align: 'center' }
      ],
      itemExpri: [
        { text: '3 เดือน', value: '3' },
        { text: '6 เดือน', value: '6' },
        { text: '9 เดือน', value: '9' },
        { text: '1 ปี', value: '12' }
      ],
      columns1: [
        { text: 'รูป', value: 'packageImg' },
        { text: 'ผู้เชิญ', value: 'packageName' },
        {
          text: 'จำนวนการเชิญ/คน',
          value: 'packageCount',
          align: 'center'
        },
        {
          text: 'คะแนนที่ได้รับทั้งหมด',
          value: 'packagePrice',
          align: 'center'
        }
      ],
      dataItem1: [],
      columns2: [
        { text: 'รูป', value: 'picture' },
        { text: 'ชื่อไลน์ลูกค้า', value: 'name' },
        { text: 'แพคเกจ', value: 'packageName' },
        {
          text: 'จำนวนครั้งที่ใช้ได้',
          value: 'amount',
          align: 'center'
        },
        {
          text: 'จำนวนครั้งที่เหลือ',
          value: 'balanceAmount',
          align: 'center'
        },
        {
          text: 'วันหมดอายุ',
          value: 'exPackage',
          align: 'center'
        }
      ],
      dataItem2: []
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    this.convertExpridate()
    this.getDataReport()
  },
  methods: {
    async getDataReport () {
      this.dataItem1 = []
      await axios
        .get(
          this.DNS_IP +
            '/reportPackageQRcode/get?shopId=' +
            this.session.data.shopId +
            '&status=used'
        )
        .then(response => {
          let rs = response.data
          this.dataItem1 = rs
          console.log('rs', this.dataItem1)
        })
    },
    async getDataPackageMember (item) {
      this.dataItem2 = []
      console.log('item', item.packageId)
      await axios
        .get(
          this.DNS_IP +
            '/PackageLog/get?shopId=' +
            this.session.data.shopId +
            '&packageId=' +
            item.packageId
        )
        .then(res => {
          this.dataItem2 = res.data
        })
    },
    convertExpridate () {
      console.log(this.dataItem)
      let month = this.dataItem
      this.dataItem = []
      for (let i = 0; i < month.length; i++) {
        let d = month[i]
        if (d.packageExpri !== '') {
          if (d.packageExpri === '12') {
            d.packageExpridate = '1 ปี'
            this.dataItem.push(d)
          } else {
            d.packageExpridate = d.packageExpri + ' เดือน'
            this.dataItem.push(d)
          }
        } else {
          d.packageExpridate = ''
          this.dataItem.push(d)
        }
      }
    }
  }
}
</script>
<style scoped>
h3 {
  font-size: 18.72px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/reportFriendGetFriend.vue